import * as z from "zod/v4";

export const getCheckoutSession = {
  name: "getCheckoutSession" as const,
  input: z.object({ checkoutSessionId: z.string() }),
  output: z.object({
    id: z.string(),
    status: z.string().nullable(),
    clientSecret: z.string().nullable(),
  }),
};
